// The one field that starts everything: a listing link. The landing page and the signed-in
// empty account share it, and both land on the same import screen.
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { ErrorText } from '@/components/ui';
import { errorMessage } from '@/lib/api';
import { onboardingApi } from '@/lib/queries';

export function ImportForm({
  loggedIn,
  autoFocus = true,
}: {
  /** Signed in: the property is the host's from the start; anonymous: it waits to be claimed. */
  loggedIn: boolean;
  autoFocus?: boolean;
}) {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const submit = async (e?: FormEvent) => {
    e?.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      const { importId } = await onboardingApi.startImport(url.trim(), loggedIn);
      void navigate(`/import/${importId}`);
    } catch (err) {
      setError(errorMessage(err));
      setBusy(false);
    }
  };

  return (
    <>
      <form
        onSubmit={submit}
        className="card float"
        style={{
          borderRadius: 20,
          borderColor: 'rgba(0,0,0,.08)',
          padding: '8px 8px 8px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <input
          className="input-bare"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="airbnb.com/rooms/… or your booking site"
          aria-label="Listing URL"
          autoFocus={autoFocus}
        />
        <button type="submit" className="btn btn-primary btn-sq hv" disabled={busy}>
          {busy ? 'Importing' : 'Import'}
          <span style={{ fontSize: 16 }}>→</span>
        </button>
      </form>
      <ErrorText>{error}</ErrorText>
    </>
  );
}
